(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtails-shopify-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtails-shopify-process')) {
    class DtailsShopifyProcess extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.section = this.closest('.dtails-process');
        this.gray = this.querySelector('[data-circle="gray"]');
        this.green = this.querySelector('[data-circle="green"]');
        this.dots = ['one', 'two', 'three'].map(name => this.querySelector(`[data-dot="${name}"]`));
        this.ring = this.querySelector('[data-ring]');
        this.stories = Array.from(this.querySelectorAll('[data-step]'));
        this.sticky = this.querySelector('.dtails-process__sticky');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.active = -1;
        this.visible = false;
        this.schedule = () => {
          if (!this.frame && this.hasAttribute('data-ready')) this.frame = requestAnimationFrame(() => this.draw());
        };
        this.measure = () => {
          const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const available = window.innerHeight - header;
          const enabled = !this.motion.matches && available >= 480;
          if (!enabled) {
            this.removeAttribute('data-ready');
            this.stories.forEach(story => story.removeAttribute('aria-hidden'));
            this.section.style.setProperty('--process-darkness', '1');
            this.section.style.setProperty('--process-text-lightness', '1');
            this.style.setProperty('--process-content-opacity', '1');
            this.style.setProperty('--process-heading-opacity', '1');
            this.querySelector('.dtails-process__heading')?.removeAttribute('aria-hidden');
            this.querySelector('.dtails-process__punchline')?.removeAttribute('aria-hidden');
            this.style.setProperty('--process-heading-offset', '0px');
            this.style.setProperty('--process-content-shift', '0px');
            this.style.setProperty('--process-punchline-shift', '0px');
            this.querySelector('.dtails-process__layout').removeAttribute('aria-hidden');
            this.renderFigure(1);
            return;
          }
          const spacing = getComputedStyle(this.sticky);
          const layout = this.querySelector('.dtails-process__content');
          const contentHeight = layout.getBoundingClientRect().height + parseFloat(spacing.paddingTop) + parseFloat(spacing.paddingBottom);
          const stageHeight = Math.max(available, contentHeight);
          this.style.setProperty('--process-stage-height', `${stageHeight}px`);
          this.sequenceDistance = available * this.timelineLength;
          this.style.setProperty('--process-scroll-distance', `${this.sequenceDistance - available * this.punchlineReleaseLength}px`);
          this.setAttribute('data-ready', '');
          this.draw();
        };
        window.addEventListener('scroll', () => { if (this.visible) this.schedule(); }, { passive: true, signal });
        window.addEventListener('resize', this.measure, { passive: true, signal });
        this.motion.addEventListener('change', this.measure, { signal });
        document.addEventListener('click', async event => {
          const link = event.target.closest('a[href="#dtails-how-we-work"]');
          const hero = document.querySelector('#MainContent > .shopify-section');
          if (!link || !hero?.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.measure();
          const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const whiteIntro = this.hasAttribute('data-ready') ? (window.innerHeight - header) * 0.18 : 0;
          const top = Math.max(0, window.scrollY + this.getBoundingClientRect().top - header + whiteIntro);
          if (this.motion.matches) {
            window.scrollTo({ top, behavior: 'instant' });
            return;
          }
          const utilities = await import('@theme/utilities').catch(() => null);
          if (!this.isConnected) return;
          const lenis = utilities?.getLenis();
          this.scrollController?.abort();
          this.scrollController = new AbortController();
          const scrollSignal = this.scrollController.signal;
          const cancel = () => {
            this.scrollController.abort();
            cancelAnimationFrame(this.scrollFrame);
            if (lenis) lenis.scrollTo(window.scrollY, { immediate: true });
          };
          ['pointermove', 'wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, cancel, { passive: true, once: true, signal: scrollSignal }));
          window.addEventListener('resize', cancel, { once: true, signal: scrollSignal });
          this.motion.addEventListener('change', cancel, { once: true, signal: scrollSignal });
          const present = () => {
            if (scrollSignal.aborted || !this.isConnected || !this.hasAttribute('data-ready')) return;
            const end = window.scrollY + this.getBoundingClientRect().top - header + this.sequenceDistance;
            const speed = (window.innerHeight - header) * 0.23;
            let previous = performance.now();
            let position = window.scrollY;
            const advance = now => {
              if (scrollSignal.aborted || !this.isConnected) return;
              if (document.hidden) { cancel(); return; }
              position = Math.min(end, position + speed * Math.min(now - previous, 50) / 1000);
              previous = now;
              if (lenis) lenis.scrollTo(position, { immediate: true });
              else window.scrollTo({ top: position, behavior: 'instant' });
              if (position < end) this.scrollFrame = requestAnimationFrame(advance);
              else this.scrollController.abort();
            };
            this.scrollFrame = requestAnimationFrame(advance);
          };
          if (lenis) {
            lenis.scrollTo(top, { duration: 1.8, easing: t => t * t * (3 - 2 * t), onComplete: present });
          } else {
            const from = window.scrollY;
            const started = performance.now();
            const advance = now => {
              if (scrollSignal.aborted || !this.isConnected) return;
              const progress = Math.min(1, (now - started) / 1800);
              const easing = progress * progress * (3 - 2 * progress);
              window.scrollTo({ top: from + (top - from) * easing, behavior: 'instant' });
              if (progress < 1) this.scrollFrame = requestAnimationFrame(advance);
              else present();
            };
            this.scrollFrame = requestAnimationFrame(advance);
          }
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const selected = event.target.closest('[data-step]');
          if (!selected || !this.contains(selected) || !this.hasAttribute('data-ready')) return;
          const lengths = this.phaseLengths;
          const index = Number(selected.dataset.step);
          const stop = (this.introLength + lengths.slice(0, index).reduce((sum, length) => sum + length, 0) + lengths[index] * 0.8) / this.timelineLength;
          const rect = this.getBoundingClientRect();
          const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          window.scrollTo({ top: window.scrollY + rect.top - header + stop * this.sequenceDistance });
          this.schedule();
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.schedule();
        });
        this.observer.observe(this);
        this.measure();
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.resizeFrame) this.resizeFrame = requestAnimationFrame(() => { this.resizeFrame = 0; this.measure(); });
        });
        this.resizeObserver.observe(this.querySelector('.dtails-process__content'));
        document.fonts?.ready.then(() => { if (this.isConnected) this.measure(); });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.scrollController?.abort();
        cancelAnimationFrame(this.scrollFrame);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.resizeFrame);
      }
      get distance() { return Math.max(1, this.offsetHeight - this.sticky.offsetHeight); }
      draw() {
        this.frame = 0;
        if (!this.hasAttribute('data-ready')) return;
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const p = Math.max(0, Math.min(1, (header - this.getBoundingClientRect().top) / this.sequenceDistance));
        const available = window.innerHeight - header;
        const smooth = value => { const x = Math.max(0, Math.min(1, value)); return x * x * (3 - 2 * x); };
        const time = p * this.timelineLength;
        const entry = smooth((time - 0.25) / 0.65);
        const exit = smooth((time - this.animationEnd) / this.exitLength);
        const punchlineStart = this.animationEnd + this.exitLength;
        const punchlineEntrance = smooth((time - punchlineStart) / this.punchlineFadeLength);
        const punchlineRelease = smooth((time - punchlineStart - this.punchlineFadeLength - this.punchlineHoldLength) / this.punchlineReleaseLength);
        const punchlineOpacity = punchlineEntrance * (1 - punchlineRelease);
        const contentOpacity = smooth((time - this.introLength) / 0.35) * (1 - exit);
        const darkness = entry * (1 - exit);
        this.section.style.setProperty('--process-darkness', String(darkness));
        this.section.style.setProperty('--process-text-lightness', String(smooth((darkness - 0.58) / 0.08)));
        this.style.setProperty('--process-content-opacity', String(contentOpacity));
        const headingOpacity = 1 - smooth((time - this.introLength) / 0.18);
        this.style.setProperty('--process-heading-opacity', String(headingOpacity));
        this.style.setProperty('--process-punchline-opacity', String(punchlineOpacity));
        this.style.setProperty('--process-content-shift', `${-available * 0.3 * exit}px`);
        this.style.setProperty('--process-punchline-shift', '0px');
        this.querySelector('.dtails-process__heading')?.setAttribute('aria-hidden', String(headingOpacity === 0));
        this.querySelector('.dtails-process__punchline')?.setAttribute('aria-hidden', String(punchlineOpacity === 0));
        const layout = this.querySelector('.dtails-process__layout');
        const heading = this.querySelector('.dtails-process__heading');
        const headingMargin = heading ? parseFloat(getComputedStyle(heading).marginBottom) : 0;
        this.style.setProperty('--process-heading-offset', `${(layout.getBoundingClientRect().height + headingMargin) * 0.5 * (1 - contentOpacity)}px`);
        layout.setAttribute('aria-hidden', String(contentOpacity === 0));
        this.renderFigure(p);
        const { step } = this.phaseAt(p);
        if (step !== this.active) {
          this.active = step;
          this.stories.forEach((story, index) => {
            story.toggleAttribute('data-active', index === step);
            story.setAttribute('aria-hidden', String(index !== step));
          });
        }
      }
      get phaseLengths() {
        const motion = Number(this.dataset.scrollLength) || 3.6;
        const hold = Number(this.dataset.holdLength) || 0.6;
        return [0.22, 0.18, 0.37, 0.23].map(part => part * motion + hold);
      }
      get introLength() { return 1.1; }
      get exitLength() { return 0.3; }
      get punchlineFadeLength() { return 0.18; }
      get punchlineHoldLength() { return 0.65; }
      get punchlineReleaseLength() { return 0.3; }
      get animationEnd() { return this.introLength + this.phaseLengths.reduce((sum, length) => sum + length, 0); }
      get timelineLength() { return this.animationEnd + this.exitLength + this.punchlineFadeLength + this.punchlineHoldLength + this.punchlineReleaseLength; }
      phaseAt(p) {
        const lengths = this.phaseLengths;
        let local = Math.max(0, Math.min(1, p)) * this.timelineLength - this.introLength;
        let step = 0;
        while (step < 3 && local >= lengths[step]) local -= lengths[step++];
        return { step, local };
      }
      renderFigure(p) {
        const smooth = value => { const x = Math.max(0, Math.min(1, value)); return x * x * (3 - 2 * x); };
        const { step, local } = this.phaseAt(p);
        const motion = Number(this.dataset.scrollLength) || 3.6;
        const entrance = step > 0 ? 1 : smooth(local / (motion * 0.22));
        const appear = step > 2 ? 1 : step === 2 ? smooth(local / (motion * 0.07)) : 0;
        const movement = step > 2 ? 1 : step === 2 ? smooth((local - motion * 0.1) / (motion * 0.23)) : 0;
        const finish = step === 3 ? smooth(local / (motion * 0.18)) : 0;
        this.green.setAttribute('cx', -12 + 124 * entrance);
        this.green.setAttribute('opacity', 0.15 + 0.85 * smooth(entrance / 0.6));
        this.gray.setAttribute('cx', 282 - 105 * entrance - 20 * finish);
        this.gray.setAttribute('r', 91 - 8 * finish);
        this.gray.setAttribute('opacity', 0.15 + 0.85 * smooth((entrance - 0.08) / 0.7));
        this.dots.forEach(dot => dot.setAttribute('opacity', appear));
        this.dots[0].setAttribute('cx', 229 - 82 * movement);
        this.dots[1].setAttribute('cx', 244 - 85 * movement);
        this.dots.slice(0, 2).forEach(dot => dot.classList.toggle('dtails-process__dot--inside', Number(dot.getAttribute('cx')) < 197));
        this.dots[2].setAttribute('cx', 225 - 7 * finish);
        this.dots[2].classList.toggle('dtails-process__dot--solved', finish > 0.5);
        this.ring.setAttribute('cx', 225 - 7 * finish);
        this.ring.setAttribute('opacity', finish > 0 ? 1 : 0);
        this.ring.setAttribute('stroke-dasharray', finish === 1 ? 'none' : `${107 * finish} 107`);
        this.ring.style.transform = 'rotate(-90deg)';
        this.ring.style.transformOrigin = `${225 - 7 * finish}px 144px`;
      }
    }
    customElements.define('dtails-shopify-process', DtailsShopifyProcess);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const controllerKey = '__dtailsFooterRevealController';

    if (window[controllerKey]?.destroy) {
      window[controllerKey].destroy();
    }

    const desktopQuery = window.matchMedia('(min-width: 768px)');
    const root = document.documentElement;
    const body = document.body;
    let observedSections = [];

    const getFooterSections = () =>
      Array.from(document.querySelectorAll('.shopify-section-group-footer-group'));

    const clearSectionOffsets = (sections) => {
      sections.forEach((section) => {
        section.style.removeProperty('--footer-reveal-bottom');
      });
    };

    const syncObservedSections = (sections) => {
      const hasChanged =
        sections.length !== observedSections.length ||
        sections.some((section, index) => section !== observedSections[index]);

      if (!hasChanged) return;

      resizeObserver.disconnect();
      observedSections = sections;

      observedSections.forEach((section) => {
        resizeObserver.observe(section);
      });
    };

    const update = () => {
      const footerSections = getFooterSections();
      syncObservedSections(footerSections);

      const revealFooter = footerSections
        .map((section) => section.querySelector('.footer--reveal-enabled'))
        .find(Boolean);
      const isEnabled = Boolean(revealFooter);
      const isActive = desktopQuery.matches && isEnabled;

      body.classList.toggle('footer-reveal-enabled', isEnabled);
      body.classList.toggle('footer-reveal-active', isActive);

      if (isEnabled) {
        const configuredRadius = Number(revealFooter?.dataset.footerRevealRadius);
        const revealRadius = Number.isFinite(configuredRadius)
          ? Math.max(0, configuredRadius)
          : 20;

        root.style.setProperty('--footer-reveal-radius', `${revealRadius}px`);
      } else {
        root.style.removeProperty('--footer-reveal-radius');
      }

      if (!isActive) {
        clearSectionOffsets(footerSections);
        root.style.removeProperty('--footer-reveal-height');
        return;
      }

      let combinedHeight = 0;

      for (let index = footerSections.length - 1; index >= 0; index -= 1) {
        const footerSection = footerSections[index];

        footerSection.style.setProperty(
          '--footer-reveal-bottom',
          `${combinedHeight}px`
        );

        combinedHeight += footerSection.getBoundingClientRect().height;
      }

      root.style.setProperty(
        '--footer-reveal-height',
        `${Math.ceil(combinedHeight)}px`
      );
    };

    const resizeObserver = new ResizeObserver(update);

    desktopQuery.addEventListener('change', update);
    window.addEventListener('resize', update);
    document.addEventListener('shopify:section:load', update);
    document.addEventListener('shopify:section:unload', update);

    requestAnimationFrame(update);

    window[controllerKey] = {
      destroy() {
        resizeObserver.disconnect();
        desktopQuery.removeEventListener('change', update);
        window.removeEventListener('resize', update);
        document.removeEventListener('shopify:section:load', update);
        document.removeEventListener('shopify:section:unload', update);
        clearSectionOffsets(getFooterSections());
        body.classList.remove('footer-reveal-enabled');
        body.classList.remove('footer-reveal-active');
        root.style.removeProperty('--footer-reveal-height');
        root.style.removeProperty('--footer-reveal-radius');
      },
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
